/* ============================================================
   MARKED · NORDSTERN — Verhalten der Homepage-V2-Sections

   Ein Asset fuer alle ns-* Sections. Jede Section meldet sich
   selbst an (data-ns-*), es gibt keine Reihenfolge-Abhaengigkeit
   und kein Init aus dem Liquid heraus, ausser wo eine Section
   Konfiguration mitgeben muss (dann ueber NS.init...).

   Doppelausfuehrung ist abgesichert: window.NS existiert nur
   einmal, und jede Wurzel bekommt ein data-*-Init-Flag.

   Branch design-pass -> Draft-Theme MARKED V2 (187658371401).
   ============================================================ */
(function () {
  if (window.NS) return;

  var NS = (window.NS = {});

  /* ---------- kleine Helfer ---------- */
  function alle(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function reduziert() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // Verhindert, dass eine Wurzel zweimal verdrahtet wird (Theme-Editor
  // laedt Sections neu, ohne die Seite neu zu bauen).
  function einmal(root, flag) {
    if (!root || root.dataset[flag] === '1') return false;
    root.dataset[flag] = '1';
    return true;
  }

  NS.alle = alle;
  NS.reduziert = reduziert;
  NS.einmal = einmal;

  /* ---------- Sprachpraefix ----------
     Shopify.routes.root ist "/" in der Hauptsprache und "/en/" in
     einer zweiten. WURZEL ist daraus das Praefix ohne Schlussstrich:
     "" beziehungsweise "/en". Damit bleibt jede URL in der
     Hauptsprache zeichengleich wie vorher.
     Siehe docs/I18N-INVENTAR.md, Abschnitt 6.3. */
  function wurzel() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r === '/' ? '' : String(r).replace(/\/+$/, '');
  }
  var WURZEL = wurzel();

  /* Setzt das Praefix vor einen shop-internen Pfad, wenn es fehlt.
     Anker, mailto, tel, Protokoll-URLs und alles, was schon im
     Praefix liegt, bleiben unberuehrt. */
  function mitWurzel(pfad) {
    if (!WURZEL || !pfad) return pfad;
    var p = String(pfad);
    if (p.charAt(0) !== '/') return p;            // Anker, relativ, mailto:
    if (p.indexOf('//') === 0) return p;          // protokollrelativ
    /* Schon drin: "/en" allein, "/en/…", "/en#…" und "/en?…". Shopify
       liefert ein URL-Setting "/#anker" als "/en#anker" aus; ohne den
       Fall "#" und "?" wurde daraus "/en/en#anker" (Runde 24). */
    var naechstes = p.charAt(WURZEL.length);
    if (p.indexOf(WURZEL) === 0 && (naechstes === '' || naechstes === '/' || naechstes === '#' || naechstes === '?')) return p;
    return WURZEL + p;
  }

  NS.wurzel = function () { return WURZEL; };
  NS.mitWurzel = mitWurzel;

  /* ---------- Sprache der Seite ----------
     <html lang> ist die Shop-Sprache (layout/theme.liquid setzt
     request.locale.iso_code). assets/coin-pdp-data.json ist je
     Sprache gegliedert; solange nur "de" darin steht, faellt jede
     andere Sprache darauf zurueck, statt leer zu laufen. */
  function sprache() {
    /* Defensiv: in Testumgebungen mit Minimal-DOM gibt es
       documentElement.getAttribute nicht. Ohne diese Pruefung wuerfe
       die Funktion, der Wurf landete im .catch des Datenladers, und
       die Ergebniszeilen blieben leer - gemessen in
       docs/tests/ns-module-check.js. */
    var el = document && document.documentElement;
    var wert = (el && el.getAttribute) ? el.getAttribute('lang') : null;
    return String(wert || 'de').slice(0, 2).toLowerCase();
  }
  function paket(d) {
    if (!d) return null;
    return d[sprache()] || d.de || null;
  }

  NS.sprache = sprache;
  NS.paket = paket;

  /* ---------- Texte aus dem Locale ----------
     snippets/ns-assets setzt window.NS_TEXTE aus locales/*.json.
     Vorrang: Section-Setting, dann Locale, dann der deutsche
     Notnagel im Code - damit bleibt ein Modul auch dann
     beschriftet, wenn ein Key einmal fehlt. */
  var TEXTE = window.NS_TEXTE || {};
  function text(name, notnagel) {
    var w = TEXTE[name];
    return (w === undefined || w === null || w === '') ? notnagel : w;
  }

  NS.text = text;

  /* ---------- Link-Praefix fuer die getippten Pfade ----------
     Die Templates tragen rund 90 Link-Settings als getippte Pfade
     ("/products/pendant-coin?design=initialen", "/pages/tarot").
     Shopify uebersetzt die nicht, also fehlt ihnen in einer zweiten
     Sprache das Praefix, und ein englischer Besucher landet wieder
     im Deutschen. Statt die Settings anzufassen (sie gehoeren dem
     Editor, und Adele arbeitet darin), setzt der Browser das
     Praefix beim Laden davor.

     In der Hauptsprache ist WURZEL leer und diese Funktion kehrt
     sofort zurueck: kein Link wird angefasst, die Seite bleibt
     zeichengleich.

     Nicht angefasst werden Anker, mailto und tel, absolute URLs mit
     Protokoll, protokollrelative Adressen, /cdn/-Pfade und alles,
     was das Praefix schon traegt. */
  function linkPraefixStarten(wurzelEl) {
    if (!WURZEL) return;
    alle('a[href]', wurzelEl || document).forEach(function (a) {
      var roh = a.getAttribute('href') || '';
      if (roh.charAt(0) !== '/') return;
      if (roh.indexOf('//') === 0) return;
      if (roh.indexOf('/cdn/') === 0) return;
      var neu = mitWurzel(roh);
      if (neu !== roh) a.setAttribute('href', neu);
    });
  }

  NS.linkPraefix = linkPraefixStarten;

  /* ============================================================
     Laufband · Trust-Rotation
     Bei reduzierter Bewegung steht das Marquee still (CSS). Dann
     wechseln die Trust-Zeilen einzeln durch, damit das Band nicht
     als angeschnittener Satz einfriert.
     ============================================================ */
  function bandStarten(root) {
    if (!einmal(root, 'nsBand')) return;

    var items = alle('.ns-band__rotator-item', root);
    if (items.length < 2) return;

    var i = 0;
    var takt = Number(root.getAttribute('data-ns-rotate') || 4000);

    function zeige(n) {
      for (var k = 0; k < items.length; k++) {
        items[k].setAttribute('data-ns-on', k === n ? '1' : '0');
      }
    }

    zeige(0);
    // Der Timer laeuft nur, wenn die Rotation ueberhaupt sichtbar ist.
    if (!reduziert()) return;
    setInterval(function () {
      i = (i + 1) % items.length;
      zeige(i);
    }, takt);
  }

  /* ============================================================
     Header · Mobil-Menue
     ============================================================ */
  function menueStarten(root) {
    // Flag nicht 'nsMenu': dataset.nsMenu IST data-ns-menu und
    // ueberschrieb die Panel-ID mit "1" (Runde 33).
    if (!einmal(root, 'nsMenuInit')) return;

    var panel = document.getElementById(root.getAttribute('data-ns-menu'));
    if (!panel) return;

    var oeffner = alle('[data-ns-menu-open]', root);
    var schliesser = alle('[data-ns-menu-close]', panel);
    var dialog = panel.querySelector('.ns-menu__panel') || panel;
    var vorher = null;
    var still = [];   // Elemente, die wir inert gesetzt haben

    // Runde 38: Zustand am Menue-Knopf, Hintergrund inert, Fokus
    // bleibt im offenen Panel (Tab und Shift+Tab laufen im Kreis).
    oeffner.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });

    // Alles ausser dem Weg zum Panel inert setzen: je Vorfahre bis
    // body dessen Geschwister. Was schon inert war, bleibt unberuehrt.
    function hintergrundStill(an) {
      if (!an) {
        still.forEach(function (el) { el.inert = false; el.removeAttribute('inert'); });
        still = [];
        return;
      }
      var knoten = dialog;
      while (knoten && knoten !== document.body) {
        var eltern = knoten.parentElement;
        if (!eltern) break;
        Array.prototype.forEach.call(eltern.children, function (k) {
          if (k === knoten || k.inert || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(k.tagName)) return;
          // Der Scrim schliesst per Klick, braucht aber keinen Fokus.
          if (k.classList && k.classList.contains('ns-menu__scrim')) return;
          k.inert = true;
          k.setAttribute('inert', '');
          still.push(k);
        });
        knoten = eltern;
      }
    }

    function fokussierbar() {
      return alle('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', dialog)
        .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    }

    function auf() {
      vorher = document.activeElement;
      panel.setAttribute('data-ns-open', '1');
      document.documentElement.style.overflow = 'hidden';
      oeffner.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      hintergrundStill(true);
      // Der Scrim ist der erste Button im Panel, aber unsichtbar.
      var erst = panel.querySelector('.ns-menu__close') || panel.querySelector('a, button');
      if (erst) erst.focus();
    }

    function zu() {
      if (panel.getAttribute('data-ns-open') !== '1') return;
      panel.setAttribute('data-ns-open', '0');
      document.documentElement.style.overflow = '';
      oeffner.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      hintergrundStill(false);
      if (vorher && vorher.focus) vorher.focus();
    }

    var scrim = panel.querySelector('.ns-menu__scrim');
    if (scrim) scrim.setAttribute('tabindex', '-1');

    oeffner.forEach(function (b) { b.addEventListener('click', auf); });
    schliesser.forEach(function (b) { b.addEventListener('click', zu); });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && panel.getAttribute('data-ns-open') === '1') zu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || panel.getAttribute('data-ns-open') !== '1') return;
      var liste = fokussierbar();
      if (!liste.length) return;
      var erst = liste[0], letzt = liste[liste.length - 1];
      var drin = dialog.contains(document.activeElement);
      if (e.shiftKey && (document.activeElement === erst || !drin)) { e.preventDefault(); letzt.focus(); }
      else if (!e.shiftKey && (document.activeElement === letzt || !drin)) { e.preventDefault(); erst.focus(); }
    });
  }

  /* ============================================================
     Karussell · Slider (Hero, PDP-Galerie)

     MOTION-REGEL: Karussells sliden, sie blenden nicht ueber.
     Die Slides liegen in einer Spur nebeneinander, der Wechsel
     laeuft ueber transform: translateX, 450ms ease-in-out. Damit
     fuehlt sich das Autoplay genauso an wie der Wisch auf Mobil -
     eine Bewegung, nicht zwei. Die Referenz-Mockups zeigen noch
     ein Crossfade; das ist bewusst nicht uebernommen.

     Loop ohne Rueckwaerts-Gerutsche: hinter den letzten Slide
     haengt eine unsichtbare Kopie des ersten. Von Slide 3 geht es
     vorwaerts auf die Kopie, und sobald die Bewegung steht, wird
     die Spur ohne Uebergang auf Slide 1 zurueckgesetzt. Man sieht
     den Sprung nicht, weil beide Bilder identisch sind.

     prefers-reduced-motion: harter Schnitt, keine Animation.
     ============================================================ */
  function sliderStarten(root, opt) {
    if (!einmal(root, 'nsSlider')) return;
    opt = opt || {};

    var spur = root.querySelector('[data-ns-track]');
    if (!spur) return;

    var echte = alle('[data-ns-slide]', spur);
    var punkte = alle('[data-ns-dot]', root);
    var anzahl = echte.length;
    if (anzahl < 2) return;

    var takt = Number(root.getAttribute('data-ns-autoplay') || 0);
    var dauer = Number(root.getAttribute('data-ns-dauer') || 450);
    var i = 0;                 // 0..anzahl (anzahl = Kopie)
    var timer = null;
    var sperre = false;        // laeuft gerade eine Bewegung?

    // Kopie des ersten Slides ans Ende. aria-hidden und ohne
    // Tab-Stopps, damit sie fuer Screenreader und Tastatur nicht
    // existiert.
    var kopie = echte[0].cloneNode(true);
    kopie.setAttribute('aria-hidden', 'true');
    kopie.removeAttribute('data-ns-slide');
    kopie.setAttribute('data-ns-klon', '1');
    alle('a, button, input', kopie).forEach(function (el) { el.setAttribute('tabindex', '-1'); });
    // Eine zweite h1 waere ein Fehler im Dokument.
    alle('h1', kopie).forEach(function (h) {
      var p = document.createElement('p');
      p.className = h.className;
      p.textContent = h.textContent;
      h.parentNode.replaceChild(p, h);
    });
    spur.appendChild(kopie);

    function setzen(n, ohneUebergang) {
      if (ohneUebergang || reduziert()) {
        spur.setAttribute('data-ns-sprung', '1');
        // Reflow erzwingen, sonst schluckt der Browser das Zuruecksetzen.
        void spur.offsetWidth;
      }
      spur.style.transform = 'translateX(' + (-n * 100) + '%)';
      if (ohneUebergang || reduziert()) {
        void spur.offsetWidth;
        spur.removeAttribute('data-ns-sprung');
      }
    }

    function punkteSetzen() {
      var sichtbar = i % anzahl;
      punkte.forEach(function (p, k) {
        p.setAttribute('data-ns-on', k === sichtbar ? '1' : '0');
        p.setAttribute('aria-current', k === sichtbar ? 'true' : 'false');
      });
      echte.forEach(function (sl, k) {
        // Was nicht im Bild ist, gehoert nicht in den Tab-Lauf.
        alle('a, button, input', sl).forEach(function (el) {
          if (k === sichtbar) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      });
    }

    function zeige(n) {
      if (sperre) return;
      if (n === i) return;
      sperre = true;
      i = n;
      setzen(i);
      punkteSetzen();
      if (reduziert()) { sperre = false; return; }
      setTimeout(function () {
        // Auf der Kopie angekommen: lautlos auf den echten ersten
        // Slide zuruecksetzen.
        if (i === anzahl) { i = 0; setzen(0, true); punkteSetzen(); }
        sperre = false;
      }, dauer + 30);
    }

    function weiter() { zeige(i + 1 > anzahl ? 1 : i + 1); }
    function zurueck() {
      if (i === 0) { setzen(anzahl, true); i = anzahl; }
      zeige(i - 1);
    }

    function taktNeu() {
      if (timer) clearInterval(timer);
      if (!takt || reduziert()) return;
      timer = setInterval(weiter, takt);
    }

    punkte.forEach(function (p, n) {
      p.addEventListener('click', function () { zeige(n); taktNeu(); });
    });

    var vorZurueck = root.querySelector('[data-ns-prev]');
    var vorWeiter = root.querySelector('[data-ns-next]');
    if (vorZurueck) vorZurueck.addEventListener('click', function () { zurueck(); taktNeu(); });
    if (vorWeiter) vorWeiter.addEventListener('click', function () { weiter(); taktNeu(); });

    // Wischen. Schwelle 48px, und nur waagerecht - sonst schluckt
    // die Geste den senkrechten Scroll.
    var startX = null, startY = null;
    root.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      startX = startY = null;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) weiter(); else zurueck();
        taktNeu();
      }
    }, { passive: true });

    // Autoplay ruht, solange das Karussell nicht im Bild ist.
    if (takt && window.IntersectionObserver) {
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) taktNeu();
          else if (timer) { clearInterval(timer); timer = null; }
        });
      }, { threshold: 0.25 }).observe(root);
    }

    // Von aussen auf einen Slide springen (Runde 48, Farbwahl der
    // Kaufbox): detail.index, detail.sofort = ohne Bewegung.
    root.addEventListener('ns:zeige', function (e) {
      var d = e.detail || {};
      var n = Number(d.index);
      if (!(n >= 0 && n < anzahl)) return;
      if (d.sofort) { i = n; setzen(n, true); punkteSetzen(); }
      else zeige(n);
      taktNeu();
    });

    setzen(0, true);
    punkteSetzen();
    taktNeu();
  }

  NS.slider = sliderStarten;

  /* ============================================================
     Kaufbox · Farbwahl (Runde 48)
     Gold oder Silber als Startwert fuer den Editor. Die Farbe ist
     keine Variante: Sie geht als color= an die Editor-Links der
     Seite (Kaufbox-CTA und Sticky-CTA, data-ns-farbe-ziel), und die
     Galerie springt auf das erste Bild dieser Farbe. Beim Laden
     ohne Bewegung, beim Tap mit.
     ============================================================ */
  function farbwahlStarten(root) {
    if (!einmal(root, 'nsFarbwahl')) return;
    var chips = alle('[data-ns-farbe-wahl]', root);
    var kauf = root.closest('.ns-kauf');
    var galerie = kauf && kauf.querySelector('.ns-kauf__galerie');

    function setzeFarbe(farbe, sofort) {
      chips.forEach(function (c) {
        c.setAttribute('aria-checked', c.getAttribute('data-ns-farbe-wahl') === farbe ? 'true' : 'false');
      });
      alle('a[data-ns-farbe-ziel]').forEach(function (a) {
        var ziel;
        try { ziel = new URL(a.getAttribute('href') || '', window.location.origin); } catch (e) { return; }
        ziel.searchParams.set('color', farbe);
        a.setAttribute('href', ziel.pathname + ziel.search + ziel.hash);
      });
      if (!galerie) return;
      var slides = alle('[data-ns-slide]', galerie);
      for (var k = 0; k < slides.length; k++) {
        if (slides[k].getAttribute('data-ns-farbe') === farbe) {
          galerie.dispatchEvent(new CustomEvent('ns:zeige', { detail: { index: k, sofort: !!sofort } }));
          break;
        }
      }
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () { setzeFarbe(c.getAttribute('data-ns-farbe-wahl'), false); });
    });
    setzeFarbe(root.getAttribute('data-ns-farbe-start') || 'gold', true);
  }

  NS.farbwahl = farbwahlStarten;

  /* ============================================================
     Welten-Kacheln · Motiv-Einblendung
     Auf Zeigergeraeten macht das CSS den Hover. Ohne Hover (Touch)
     waere die Einblendung nie zu sehen - dort blendet das Motiv
     ein, sobald die Kachel im Bild steht.
     ============================================================ */
  function weltStarten(root) {
    if (!einmal(root, 'nsWelt')) return;

    var motiv = root.querySelector('[data-ns-motiv]');
    if (!motiv) return;

    var hatHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    if (hatHover) return;

    if (!window.IntersectionObserver) {
      // Ohne Beobachter lieber sichtbar als nie: das Motiv ist der
      // Kern des Gimmicks.
      motiv.setAttribute('data-ns-on', '1');
      return;
    }

    /* Einmal an, immer an: nichts blendet beim Scrollen wieder aus.
       Sobald das Motiv stand, wird die Kachel nicht mehr beobachtet -
       das spart den Ruecksetz-Zweig und den Beobachter gleich mit.

       Schwelle 0.4 statt 0.6: auf schmalen Geraeten steht die Kachel
       selten zu zwei Dritteln im Bild, das Motiv kam dadurch spaet
       oder gar nicht. */
    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.intersectionRatio <= 0.4) return;
        motiv.setAttribute('data-ns-on', '1');
        beobachter.unobserve(root);
      });
    }, { threshold: [0, 0.4, 1] });
    beobachter.observe(root);
  }

  /* ============================================================
     Sternzeichen und Lebenszahl · reine Rechnung

     Tabelle und Rechenweg sind ZEICHENGLEICH aus
     assets/coin-pdp-controller.js uebernommen (ZODIAC, findSign,
     computeGrad, buildNumerology). Damit rechnet die Homepage
     dasselbe wie die Coin-PDP: dieselben Zeichengrenzen, dieselbe
     Dekade, Numerologie ohne Meisterzahlen.

     Die TEXTE kommen ausschliesslich aus
     assets/coin-pdp-data.json (de.zodiac / de.numerology_meanings).
     Hier stehen keine Deutungen.

     Bekannte Doppelung: die Rechnung liegt jetzt an zwei Stellen.
     Eine gemeinsame Quelle waere besser, haette aber die PDP
     angefasst - siehe REVISION.md, offener Punkt.
     ============================================================ */
  var ZODIAC = [
    { key: 'capricorn',   name: 'Steinbock',  sM: 12, sD: 22, eM: 1,  eD: 19 },
    { key: 'aquarius',    name: 'Wassermann', sM: 1,  sD: 20, eM: 2,  eD: 18 },
    { key: 'pisces',      name: 'Fische',     sM: 2,  sD: 19, eM: 3,  eD: 20 },
    { key: 'aries',       name: 'Widder',     sM: 3,  sD: 21, eM: 4,  eD: 19 },
    { key: 'taurus',      name: 'Stier',      sM: 4,  sD: 20, eM: 5,  eD: 20 },
    { key: 'gemini',      name: 'Zwillinge',  sM: 5,  sD: 21, eM: 6,  eD: 20 },
    { key: 'cancer',      name: 'Krebs',      sM: 6,  sD: 21, eM: 7,  eD: 22 },
    { key: 'leo',         name: 'Löwe',       sM: 7,  sD: 23, eM: 8,  eD: 22 },
    { key: 'virgo',       name: 'Jungfrau',   sM: 8,  sD: 23, eM: 9,  eD: 22 },
    { key: 'libra',       name: 'Waage',      sM: 9,  sD: 23, eM: 10, eD: 22 },
    { key: 'scorpio',     name: 'Skorpion',   sM: 10, sD: 23, eM: 11, eD: 21 },
    { key: 'sagittarius', name: 'Schütze',    sM: 11, sD: 22, eM: 12, eD: 21 }
  ];

  function zeichenFinden(tag, monat) {
    for (var i = 0; i < ZODIAC.length; i++) {
      var z = ZODIAC[i];
      if ((monat === z.sM && tag >= z.sD) || (monat === z.eM && tag <= z.eD)) return z;
    }
    return null;
  }

  // Grad (Tag-im-Zeichen, linear 1..30) + Dekade (0..2).
  // Referenzjahr 2001 (kein Schaltjahr) - wie in der PDP.
  function dekadeVon(zeichen, tag, monat) {
    var refY = 2001, springt = zeichen.sM > zeichen.eM;
    var start = new Date(refY, zeichen.sM - 1, zeichen.sD);
    var gegeben, ende;
    if (springt) {
      ende = new Date(refY + 1, zeichen.eM - 1, zeichen.eD);
      gegeben = (monat === zeichen.sM) ? new Date(refY, monat - 1, tag) : new Date(refY + 1, monat - 1, tag);
    } else {
      ende = new Date(refY, zeichen.eM - 1, zeichen.eD);
      gegeben = new Date(refY, monat - 1, tag);
    }
    var TAG = 86400000;
    var index = Math.round((gegeben - start) / TAG) + 1;
    var laenge = Math.round((ende - start) / TAG) + 1;
    var grad = laenge > 1 ? Math.round((index - 1) / (laenge - 1) * 29) + 1 : 1;
    if (grad < 1) grad = 1;
    if (grad > 30) grad = 30;
    return grad <= 10 ? 0 : (grad <= 20 ? 1 : 2);
  }

  // Numerologie: DDMMYYYY, alle Ziffern, reduziert 1..9,
  // KEINE Meisterzahlen - wie in der PDP.
  function lebenszahl(ziffern) {
    var cur = ziffern.split(''), summe;
    while (true) {
      summe = cur.reduce(function (a, c) { return a + parseInt(c, 10); }, 0);
      if (summe > 9) cur = String(summe).split('');
      else return summe;
    }
  }

  function nurZiffern(wert) { return String(wert || '').replace(/\D/g, ''); }

  function datumFormat(ziffern) {
    if (ziffern.length > 4) return ziffern.slice(0, 2) + '.' + ziffern.slice(2, 4) + '.' + ziffern.slice(4);
    if (ziffern.length > 2) return ziffern.slice(0, 2) + '.' + ziffern.slice(2);
    return ziffern;
  }

  // dob als ISO (YYYY-MM-DD) - der Vertrag des Editors.
  function isoAus(ziffern) {
    return ziffern.slice(4) + '-' + ziffern.slice(2, 4) + '-' + ziffern.slice(0, 2);
  }

  // Gibt es das Datum? TTMMJJJJ gegen den echten Kalender, Jahr ab
  // 1900, nicht in der Zukunft. 31.02.2000 und 29.02.2001 fallen
  // durch (Runde 33). Acht Ziffern allein reichen nicht.
  function datumGueltig(ziffern) {
    if (!/^\d{8}$/.test(ziffern)) return false;
    var t = Number(ziffern.slice(0, 2)), m = Number(ziffern.slice(2, 4)), j = Number(ziffern.slice(4));
    var d = new Date(j, m - 1, t);
    if (d.getFullYear() !== j || d.getMonth() !== m - 1 || d.getDate() !== t) return false;
    return j >= 1900 && d <= new Date();
  }

  function ungueltigMarkieren(feld, falsch) {
    if (!feld) return;
    if (falsch) feld.setAttribute('aria-invalid', 'true');
    else feld.removeAttribute('aria-invalid');
  }

  function textUngueltig() { return text('datumUngueltig', 'Dieses Datum gibt es nicht.'); }

  NS.datumGueltig = datumGueltig;
  NS.zeichenFinden = zeichenFinden;
  NS.dekadeVon = dekadeVon;
  NS.lebenszahl = lebenszahl;

  /* ---------- Datenquelle: einmal laden, alle teilen ---------- */
  var datenCache = null;

  function datenLaden(url) {
    if (datenCache) return datenCache;
    datenCache = fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Datenquelle nicht erreichbar: ' + r.status);
      return r.json();
    });
    return datenCache;
  }

  NS.datenLaden = datenLaden;

  /* ============================================================
     Live-Gravur-Modul
     Geburtsdatum eingeben -> Sternbild bzw. Ziffer erscheint im
     Foto, die Ergebniszeile nennt Zeichen und Deutung, und der
     CTA haengt design= und dob= an.
     ============================================================ */
  function gravurStarten(root, opt) {
    if (!einmal(root, 'nsGravur')) return;
    opt = opt || {};

    var feld = root.querySelector('[data-ns-datum]');
    var chips = alle('[data-ns-chip]', root);
    var overlay = root.querySelector('[data-ns-overlay]');
    var ovArt = root.querySelector('[data-ns-ovart]');
    var ovZahl = root.querySelector('[data-ns-ovzahl]');
    var zeile = root.querySelector('[data-ns-ergebnis]');
    var cta = root.querySelector('[data-ns-cta]');
    if (!feld) return;

    var modus = root.getAttribute('data-ns-startmodus') || 'sternzeichen';
    var daten = null;

    datenLaden(opt.datenUrl).then(function (d) {
      daten = paket(d);
      zeichnen();
    }).catch(function () {
      // Ohne Daten bleibt die Zeile beim Hinweistext stehen; das
      // Overlay und der CTA arbeiten weiter, sie brauchen die
      // Texte nicht.
      zeichnen();
    });

    function zeichnen() {
      var ziffern = nurZiffern(feld.value);
      var fertig = ziffern.length === 8;

      // Eingabe waehrend des Tippens punktiert nachziehen.
      var formatiert = datumFormat(ziffern);
      if (feld.value !== formatiert) {
        var amEnde = feld.selectionStart === feld.value.length;
        feld.value = formatiert;
        if (amEnde) feld.setSelectionRange(formatiert.length, formatiert.length);
      }

      chips.forEach(function (c) {
        c.setAttribute('aria-pressed', c.getAttribute('data-ns-chip') === modus ? 'true' : 'false');
      });
      if (overlay) overlay.setAttribute('data-ns-modus', modus);
      ungueltigMarkieren(feld, false);

      if (!fertig) {
        if (overlay) overlay.setAttribute('data-ns-on', '0');
        if (zeile) zeile.textContent = opt.hinweis || '';
        if (cta) cta.setAttribute('href', opt.ctaBasis || '#');
        return;
      }

      if (!datumGueltig(ziffern)) {
        if (overlay) overlay.setAttribute('data-ns-on', '0');
        if (zeile) zeile.textContent = textUngueltig();
        if (cta) cta.setAttribute('href', opt.ctaBasis || '#');
        ungueltigMarkieren(feld, true);
        return;
      }

      var tag = Number(ziffern.slice(0, 2));
      var monat = Math.min(12, Math.max(1, Number(ziffern.slice(2, 4))));

      if (modus === 'zahlen') {
        var n = lebenszahl(ziffern);
        if (ovZahl) ovZahl.textContent = String(n);
        var bedeutung = daten && daten.numerology_meanings ? daten.numerology_meanings[String(n)] : null;
        if (zeile) {
          zeile.textContent = bedeutung
            ? (opt.zahlLabel || text('weltZahl', 'Lebenszahl')) + ' ' + n + ' · ' + bedeutung.keywords
            : (opt.zahlLabel || text('weltZahl', 'Lebenszahl')) + ' ' + n;
        }
      } else {
        var z = zeichenFinden(tag, monat);
        if (z) {
          if (ovArt && opt.zodiacArt && opt.zodiacArt[z.key]) {
            var neu = opt.zodiacArt[z.key];
            if (ovArt.getAttribute('src') !== neu) ovArt.setAttribute('src', neu);
          }
          var zd = daten && daten.zodiac ? daten.zodiac[z.key] : null;
          var dek = zd && zd.decans ? zd.decans[dekadeVon(z, tag, monat)] : null;
          if (zeile) {
            zeile.textContent = dek ? (zd.name || z.name) + ' · ' + dek.text : (zd && zd.name) || z.name;
          }
        }
      }

      if (overlay) overlay.setAttribute('data-ns-on', '1');

      if (cta && opt.ctaBasis) {
        var trenner = opt.ctaBasis.indexOf('?') === -1 ? '?' : '&';
        cta.setAttribute('href', opt.ctaBasis + trenner + 'design=' + encodeURIComponent(modus) + '&dob=' + isoAus(ziffern));
      }

      if (zeile) {
        zeile.setAttribute('data-ns-frisch', '0');
        void zeile.offsetWidth;
        zeile.setAttribute('data-ns-frisch', '1');
      }
    }

    feld.addEventListener('input', zeichnen);
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        modus = c.getAttribute('data-ns-chip');
        zeichnen();
      });
    });

    zeichnen();
  }

  NS.gravur = gravurStarten;

  /* ============================================================
     Geburtskarte · reine Rechnung

     ZEICHENGLEICH aus assets/mv3-tarot.js portiert (geburtskarte
     + quersumme). Die Formel ist dort seit der Tarot-Runde vom
     11.08. im Einsatz und stammt aus der Referenz von damals:

       alle Ziffern des Geburtsdatums addieren
       solange die Summe > 22 ist, per Quersumme reduzieren
       22 wird zu 0 (Der Narr)

     Im Paar-Modus fliessen BEIDE Daten in dieselbe Summe - nicht
     zwei Karten, sondern eine gemeinsame.

     Die Runde-6-Referenz enthaelt an dieser Stelle keine
     Rechenlogik. Portiert wird deshalb der Bestand, nicht geraten.

     Bekannte Doppelung wie bei der Sternzeichen-Rechnung: die
     Formel liegt jetzt an zwei Stellen. docs/tests/ns-tarot-check.js
     vergleicht sie gegen das Original.
     ============================================================ */
  function quersumme(n) {
    var s = String(n), summe = 0;
    for (var i = 0; i < s.length; i++) summe += Number(s.charAt(i));
    return summe;
  }

  function geburtskarte(datenListe) {
    var summe = 0, i, j;
    for (i = 0; i < datenListe.length; i++) {
      var d = datenListe[i];
      for (j = 0; j < d.length; j++) summe += Number(d.charAt(j));
    }
    while (summe > 22) summe = quersumme(summe);
    return summe === 22 ? 0 : summe;
  }

  NS.geburtskarte = geburtskarte;

  /* ============================================================
     Tarot · welches Bild zu welchem Index

     Zwei Mappings in assets/coin-pdp-data.json:
       tarot_artworks  Index -> die KARTE (Tarot-Artwork)
       tarot_images    Index -> das PRODUKT (gravierter Anhaenger)

     Wo die Karte gemeint ist - Zeremonie, Deck-Reveal, Galerie -
     gewinnt das Artwork. Fehlt ein Index dort, faellt es auf den
     Produktrender zurueck. Produkt-Buehnen nehmen weiter direkt
     tarot_images.

     Der Rueckfall bleibt auch dann stehen, wenn gerade alle 22
     Artworks vorhanden sind: er ist die Zusage, dass eine
     entfernte oder neu hinzukommende Datei nichts kaputt macht.
     ============================================================ */
  function tarotBilder(daten, anzahl) {
    var art = (daten && daten.tarot_artworks) || {};
    var prod = (daten && daten.tarot_images) || [];
    var n = anzahl || prod.length || 22;
    var raus = [];
    for (var i = 0; i < n; i++) {
      raus.push(art[i] || art[String(i)] || prod[i] || null);
    }
    return raus;
  }

  NS.tarotBilder = tarotBilder;

  /* ============================================================
     Tarot-Zeremonie · Mischen -> Ziehen -> Aufdecken

     Ablauf und Zeiten wie im Referenz-JS:
       0ms    Mischstufe 1, Karte zu
       300ms  Mischstufe 2
       620ms  Mischstufe 3
       940ms  Mischstufe 4, die mittlere Karte zieht, neues Blatt
       1340ms Aufdecken
       1840ms Ruhe
     Waehrend der Zeremonie ist der Knopf gesperrt, damit sich die
     Stufen nicht ueberlagern.

     Bei prefers-reduced-motion faellt die Zeremonie weg: die neue
     Karte liegt sofort offen da (direkter Reveal).

     Texte aus de.tarot. Das Bild ist die KARTE aus tarot_artworks;
     fehlt der Index dort, faellt es auf tarot_images zurueck - das
     ist der Produktrender des gravierten Anhaengers. Beides aus
     assets/coin-pdp-data.json, KEINE zweite Quelle.
     ============================================================ */
  var MISCH = [
    [0, 0, 0, 0, 0, 0, 0],
    [-18, 12, -8, 20, -14, 6, -10],
    [14, -16, 22, -6, 10, -20, 8],
    [-8, 6, -14, 10, -4, 12, -6],
    [0, 0, 0, 0, 0, 0, 0]
  ];

  function tarotStarten(root, opt) {
    if (!einmal(root, 'nsTarot')) return;
    opt = opt || {};

    var ruecken = alle('[data-ns-ruecken]', root);
    var karte = root.querySelector('[data-ns-karte]');
    var bild = root.querySelector('[data-ns-kartenbild]');
    var textBlock = root.querySelector('[data-ns-kartentext]');
    var elNummer = root.querySelector('[data-ns-nummer]');
    var elName = root.querySelector('[data-ns-name]');
    var elKeywords = root.querySelector('[data-ns-keywords]');
    var elReading = root.querySelector('[data-ns-reading]');
    var knopf = root.querySelector('[data-ns-ziehen]');
    var nochmal = root.querySelector('[data-ns-nochmal]');
    var cta = root.querySelector('[data-ns-kartencta]');

    var karten = [];   // de.tarot
    var bilder = [];   // Index -> Bild, Karte vor Produktrender
    var index = Number(root.getAttribute('data-ns-start') || 0);
    var phase = 'ruhe';
    var timer = [];
    var textZiehen = opt.textZiehen || text('tarotZiehen', 'Karte ziehen');
    var textLaeuft = opt.textLaeuft || text('tarotMischt', 'Das Deck mischt');

    function stufeSetzen(stufe, ziehtMitte) {
      var mitte = (ruecken.length - 1) / 2;
      ruecken.forEach(function (el, i) {
        var versatz = (MISCH[stufe] && MISCH[stufe][i]) || 0;
        var zieht = ziehtMitte && i === Math.round(mitte);
        el.style.setProperty('--ns-winkel', ((i - mitte) * 6 + versatz * 0.5) + 'deg');
        el.style.setProperty('--ns-schub', versatz + 'px');
        el.style.setProperty('--ns-hub', zieht ? '-40px' : (i === Math.round(mitte) ? '-14px' : '0px'));
        el.style.opacity = zieht ? '0' : '1';
      });
    }

    function knopfZustand() {
      var laeuft = phase !== 'ruhe';
      [knopf, nochmal].forEach(function (b) {
        if (!b) return;
        if (laeuft) b.setAttribute('disabled', 'disabled');
        else b.removeAttribute('disabled');
      });
      if (knopf) knopf.textContent = laeuft ? textLaeuft : textZiehen;
    }

    function kartenSchreiben(i) {
      var k = karten[i];
      if (!k) return;
      if (elNummer) elNummer.textContent = k.number || '';
      if (elName) elName.textContent = k.name || '';
      if (elKeywords) elKeywords.textContent = k.keywords || '';
      if (elReading) elReading.textContent = k.text || '';
      if (bild && bilder[i]) {
        bild.setAttribute('src', bilder[i]);
        bild.setAttribute('alt', k.name || '');
      }
      if (cta && opt.ctaBasis) {
        var trenner = opt.ctaBasis.indexOf('?') === -1 ? '?' : '&';
        cta.setAttribute('href', opt.ctaBasis + trenner + 'design=tarot&card=' + i);
      }
    }

    function aufdecken(auf) {
      if (karte) karte.setAttribute('data-ns-auf', auf ? '1' : '0');
      if (textBlock) textBlock.setAttribute('data-ns-auf', auf ? '1' : '0');
    }

    function timerLeeren() {
      timer.forEach(clearTimeout);
      timer = [];
    }

    function ziehen() {
      if (phase !== 'ruhe' || karten.length === 0) return;

      // Nie zweimal dieselbe Karte hintereinander.
      var neu = Math.floor(Math.random() * karten.length);
      if (neu === index && karten.length > 1) neu = (neu + 1) % karten.length;

      if (reduziert()) {
        // Direkter Reveal: kein Mischen, keine Zwischenstufen.
        index = neu;
        kartenSchreiben(index);
        seitenCta('card', index);
        aufdecken(true);
        stufeSetzen(0, false);
        return;
      }

      timerLeeren();
      phase = 'mischen';
      knopfZustand();
      aufdecken(false);
      stufeSetzen(1, false);

      timer.push(setTimeout(function () { stufeSetzen(2, false); }, 300));
      timer.push(setTimeout(function () { stufeSetzen(3, false); }, 620));
      timer.push(setTimeout(function () {
        phase = 'ziehen';
        index = neu;
        kartenSchreiben(index);
        seitenCta('card', index);
        stufeSetzen(4, true);
        if (karte) karte.setAttribute('data-ns-hub', '1');
      }, 940));
      timer.push(setTimeout(function () {
        phase = 'aufdecken';
        if (karte) karte.setAttribute('data-ns-hub', '0');
        aufdecken(true);
      }, 1340));
      timer.push(setTimeout(function () {
        phase = 'ruhe';
        knopfZustand();
        stufeSetzen(0, false);
      }, 1840));
    }

    datenLaden(opt.datenUrl).then(function (d) {
      karten = (paket(d) && paket(d).tarot) || [];
      bilder = NS.tarotBilder(d, karten.length);
      if (karten.length === 0) {
        // Ohne Daten bleibt die Zeremonie aus: ein Knopf, der nichts
        // aufdeckt, ist schlimmer als kein Knopf.
        if (knopf) knopf.setAttribute('disabled', 'disabled');
        return;
      }
      if (index >= karten.length) index = 0;
      kartenSchreiben(index);
      aufdecken(true);
      stufeSetzen(0, false);
      knopfZustand();
    }).catch(function () {
      if (knopf) knopf.setAttribute('disabled', 'disabled');
    });

    if (knopf) knopf.addEventListener('click', ziehen);
    if (nochmal) nochmal.addEventListener('click', ziehen);

    stufeSetzen(0, false);
    knopfZustand();
  }

  NS.tarot = tarotStarten;

  /* ============================================================
     Finder · drei Fragen, ein Vorschlag

     Die Zuordnung steckt NICHT im Code: jede Antwort traegt ihre
     Wirkung als data-Attribut. Die Anlass-Chips bringen Welt-Key
     und Welt-Label mit, die Stil-Chips Produkt-Name und Ziel, die
     Wen-Kacheln die Anrede. Damit laesst sich der Finder im Editor
     umbauen, ohne dieses Asset anzufassen.

     Ziel: /products/<handle>?design=<key> - ohne view=fullscreen.
     Das ist Stufe 4 der CTA-Regel: der Vorschlag verteilt auf die
     Produktseite mit vorgewaehlter Welt, er springt nicht in den
     Editor.
     ============================================================ */
  function finderStarten(root, opt) {
    if (!einmal(root, 'nsFinder')) return;
    opt = opt || {};

    var panes = alle('[data-ns-pane]', root);
    var elSchritt = root.querySelector('[data-ns-schrittlabel]');
    var elFrage = root.querySelector('[data-ns-frage]');
    var zurueck = root.querySelector('[data-ns-zurueck]');
    var nochmal = root.querySelector('[data-ns-nochmal]');

    var elProdukt = root.querySelector('[data-ns-ergprodukt]');
    var elWelt = root.querySelector('[data-ns-ergwelt]');
    var elSatz = root.querySelector('[data-ns-ergsatz]');
    var elCta = root.querySelector('[data-ns-ergcta]');
    var elBild = root.querySelector('[data-ns-ergbild]');

    var fragen = (opt.fragen || []).slice();
    var schritt = 0;
    var wahl = { wen: null, anlass: null, stil: null };

    function paneZeigen(n) {
      panes.forEach(function (pane, i) {
        var an = i === n;
        pane.hidden = !an;
        if (an && !reduziert()) {
          pane.setAttribute('data-ns-frisch', '0');
          void pane.offsetWidth;
          pane.setAttribute('data-ns-frisch', '1');
        }
      });
    }

    function ergebnisSchreiben() {
      var stil = wahl.stil, anlass = wahl.anlass, wen = wahl.wen;
      if (!stil || !anlass) return;

      var produktName = stil.getAttribute('data-ns-produktname') || '';
      var handle = stil.getAttribute('data-ns-handle') || '';
      var weltKey = anlass.getAttribute('data-ns-weltkey') || '';
      var weltLabel = anlass.getAttribute('data-ns-weltlabel') || '';
      var anrede = wen ? (wen.getAttribute('data-ns-anrede') || '') : '';

      if (elProdukt) elProdukt.textContent = produktName;
      if (elWelt) elWelt.textContent = weltLabel;
      if (elSatz) {
        elSatz.textContent = (opt.satz || text('finderSatz', '{produkt} mit {welt}, graviert {fuer}.'))
          .replace('{produkt}', produktName)
          .replace('{welt}', weltLabel)
          .replace('{fuer}', anrede);
      }
      if (elCta && handle) {
        elCta.setAttribute('href', mitWurzel('/products/' + handle) + (weltKey ? '?design=' + encodeURIComponent(weltKey) : ''));
      }
      // Ergebnisbild: eigenes Bild des Stil-Chips, sonst bleibt der
      // Brief stehen.
      if (elBild) {
        var quelle = stil.getAttribute('data-ns-ergbildurl');
        var img = elBild.querySelector('img');
        if (quelle && img) { img.setAttribute('src', quelle); img.setAttribute('alt', produktName); }
      }
    }

    function zeichnen() {
      if (elSchritt) {
        elSchritt.textContent = schritt < 3
          ? (opt.schrittWort || text('finderSchritt', 'Schritt')) + ' ' + (schritt + 1)
            + ' ' + (opt.vonWort || text('finderVon', 'von')) + ' 3'
          : (opt.ergebnisWort || text('finderErgebnis', 'Ergebnis'));
      }
      if (elFrage) elFrage.textContent = fragen[Math.min(3, schritt)] || '';
      if (zurueck) zurueck.hidden = !(schritt > 0 && schritt < 3);
      if (schritt >= 3) ergebnisSchreiben();
      paneZeigen(Math.min(3, schritt));
    }

    function waehlen(feld, el, gruppe) {
      wahl[feld] = el;
      gruppe.forEach(function (g) {
        g.setAttribute('aria-pressed', g === el ? 'true' : 'false');
      });
      schritt = Math.min(3, schritt + 1);
      zeichnen();
    }

    ['wen', 'anlass', 'stil'].forEach(function (feld) {
      var gruppe = alle('[data-ns-' + feld + ']', root);
      gruppe.forEach(function (el) {
        el.addEventListener('click', function () { waehlen(feld, el, gruppe); });
      });
    });

    if (zurueck) {
      zurueck.addEventListener('click', function () {
        schritt = Math.max(0, schritt - 1);
        zeichnen();
      });
    }
    if (nochmal) {
      nochmal.addEventListener('click', function () {
        schritt = 0;
        wahl = { wen: null, anlass: null, stil: null };
        alle('[aria-pressed="true"]', root).forEach(function (el) {
          el.setAttribute('aria-pressed', 'false');
        });
        zeichnen();
      });
    }

    zeichnen();
  }

  NS.finder = finderStarten;

  /* ============================================================
     Kachelband · Pfeil und Ende-Erkennung

     Der Pfeil blaettert um genau eine Kachelbreite plus Fuge weiter
     und blendet aus, sobald das Band am Ende steht. Gemessen wird
     am Band selbst, nicht an einer gezaehlten Kachelzahl - so
     stimmt es auch, wenn im Editor Kacheln dazukommen.

     Im Desktop-Raster gibt es keinen Scroll; der Pfeil ist dort per
     CSS ausgeblendet und die Ende-Erkennung meldet schlicht "Ende".
     ============================================================ */
  function kbandStarten(root) {
    if (!einmal(root, 'nsKband')) return;

    var rail = root.querySelector('[data-ns-kband-rail]');
    var pfeil = root.querySelector('[data-ns-kband-pfeil]');
    if (!rail || !pfeil) return;

    function amEnde() {
      // 12px Toleranz: Sub-Pixel und Scroll-Snap treffen selten exakt.
      return rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 12;
    }

    function pfeilPruefen() {
      pfeil.setAttribute('data-ns-ende', amEnde() ? '1' : '0');
    }

    pfeil.addEventListener('click', function () {
      var kachel = rail.querySelector('.ns-kachel');
      var fuge = parseFloat(getComputedStyle(rail).gap) || 8;
      var schritt = kachel ? kachel.getBoundingClientRect().width + fuge : rail.clientWidth * 0.8;
      // Bei reduzierter Bewegung springt das Band, statt zu gleiten
      // (das Gleiten kommt sonst aus scroll-behavior im CSS).
      rail.scrollBy({ left: schritt, behavior: reduziert() ? 'auto' : 'smooth' });
    });

    rail.addEventListener('scroll', pfeilPruefen, { passive: true });
    window.addEventListener('resize', pfeilPruefen);
    pfeilPruefen();
  }

  /* ============================================================
     Wechsel zwischen Live-Gravur und Finder

     Der Standardzustand zeigt NUR das Gravur-Modul; der Finder ist
     zugeklappt. Der leise Link am Fuss des Moduls klappt um: das
     eine zu, das andere auf, und seine Beschriftung wechselt
     zwischen "Lieber drei Fragen? Zum Finder" und "Zurück zum
     Datum". Es ist immer genau eines von beiden zu sehen.

     Vorher war der Link ein reiner Anker (#finder): er sprang nur
     hin, und beide Module standen dauerhaft offen. Der Finder
     zeigte dabei "Schritt 1 von 3" ohne Ueberschrift mitten in
     der Seite.

     Der Knopf sitzt AUSSERHALB des Klapp-Bereichs - er muss in
     beiden Zustaenden sichtbar bleiben, sonst gaebe es keinen Weg
     zurueck.

     Ohne JS bleibt das Gravur-Modul offen und der Finder zu; der
     Knopf tut dann nichts, verspricht aber auch nichts.
     ============================================================ */
  function wechselStarten(knopf) {
    if (!einmal(knopf, 'nsWechsel')) return;

    // Der eigene Klapp-Bereich ist der naechste in derselben Section.
    var meineSection = knopf.closest('section') || knopf.parentElement;
    var meiner = meineSection ? meineSection.querySelector('[data-ns-klapp]') : null;

    var zielId = knopf.getAttribute('data-ns-ziel');
    var zielAnker = zielId ? document.getElementById(zielId) : null;
    var zielSection = zielAnker ? (zielAnker.closest('section') || zielAnker.parentElement) : null;
    var anderer = zielSection ? zielSection.querySelector('[data-ns-klapp]') : null;
    if (!meiner || !anderer) return;

    var hin = knopf.getAttribute('data-ns-label-hin') || knopf.textContent;
    var zurueck = knopf.getAttribute('data-ns-label-zurueck') || hin;

    function setzen(finderOffen) {
      meiner.setAttribute('data-ns-offen', finderOffen ? '0' : '1');
      anderer.setAttribute('data-ns-offen', finderOffen ? '1' : '0');
      knopf.textContent = finderOffen ? zurueck : hin;
      knopf.setAttribute('aria-expanded', finderOffen ? 'true' : 'false');
      // Was zu ist, gehoert nicht in den Tab-Lauf. visibility:hidden
      // im CSS erledigt das fuer alle Kinder auf einen Schlag.
    }

    knopf.addEventListener('click', function () {
      var jetztOffen = anderer.getAttribute('data-ns-offen') === '1';
      setzen(!jetztOffen);
      if (!jetztOffen) {
        // Beim Aufklappen an den Anfang des Finders gehen, damit die
        // Ueberschrift im Bild steht und nicht der Schritt-Zaehler.
        //
        // ERST wenn die Bewegung steht: waehrend des Klappens
        // schrumpft das Modul darueber um seine volle Hoehe und der
        // Finder waechst - waehrenddessen liegt das Ziel noch ganz
        // woanders, und der Sprung landet zu weit unten.
        var hin = function () {
          if (zielSection && zielSection.scrollIntoView) {
            zielSection.scrollIntoView({ block: 'start', behavior: reduziert() ? 'auto' : 'smooth' });
          }
          var erst = anderer.querySelector('button, a, input');
          if (erst && erst.focus) erst.focus({ preventScroll: true });
        };
        if (reduziert()) { hin(); }
        else {
          var fertig = false;
          var einmalHin = function () { if (fertig) return; fertig = true; hin(); };
          anderer.addEventListener('transitionend', einmalHin, { once: true });
          // Falls kein transitionend kommt (z.B. weil sich nichts
          // bewegt hat), trotzdem springen.
          setTimeout(einmalHin, 420);
        }
      }
    });

    // Startzustand aus dem Markup uebernehmen und einmal sauber setzen.
    setzen(anderer.getAttribute('data-ns-offen') === '1');
  }

  /* ============================================================
     Monogramm-Preview (Ornament)

     Zwei Buchstabenfelder, das Zeichen erscheint live im Foto.
     Fehlt einer der beiden, verschwindet das Monogramm und die
     Zeile sagt, was noch fehlt - kein halbes Monogramm auf dem
     Anhaenger.

     Der CTA traegt seit Runde 12 zusaetzlich &initials=<AB> aus
     den beiden Feldern; der ausgelieferte Block liest den
     Parameter (:7241). Fehlt ein Buchstabe, bleibt der CTA auf
     der Basis - ein halbes Monogramm reicht der Editor nicht
     weiter. Grenze und Beleg: ns-monogramm.liquid oben.
     ============================================================ */
  function monogrammStarten(root, opt) {
    if (!einmal(root, 'nsMono')) return;
    opt = opt || {};

    var a = root.querySelector('[data-ns-mono-a]');
    var b = root.querySelector('[data-ns-mono-b]');
    var overlay = root.querySelector('[data-ns-mono-overlay]');
    var zeichen = root.querySelector('[data-ns-mono-zeichen]');
    var zeile = root.querySelector('[data-ns-mono-zeile]');
    var cta = root.querySelector('[data-ns-mono-cta]');
    if (!a || !b || !zeichen) return;
    var trenner = (cta && cta.getAttribute('data-ns-mono-trenner')) || '&';

    // Nur Buchstaben, genau einer, immer gross.
    function saeubern(feld) {
      var wert = (feld.value || '').replace(/[^\p{L}]/gu, '').slice(-1).toUpperCase();
      if (feld.value !== wert) feld.value = wert;
      return wert;
    }

    function zeichnen() {
      var x = saeubern(a);
      var y = saeubern(b);
      var fertig = !!(x && y);

      /* Runde 47: dasselbe Zeichen wie im Editor (Stil Initialen +
         Zeichen), nicht mehr der Punkt. */
      zeichen.textContent = fertig ? x + ' ' + trenner + ' ' + y : '';
      if (overlay) overlay.setAttribute('data-ns-on', fertig ? '1' : '0');
      // Format wie der ausgelieferte Block es liest: ein oder zwei
      // Buchstaben, Trenner egal, Grossschreibung macht er selbst.
      if (cta && opt.ctaBasis) {
        cta.setAttribute('href', fertig
          ? opt.ctaBasis + '&initials=' + encodeURIComponent(x + y)
          : opt.ctaBasis);
      }
      if (zeile) {
        zeile.textContent = fertig
          ? (opt.zeileFertig || '')
          : (opt.zeileOffen || '');
        zeile.setAttribute('data-ns-frisch', '0');
        void zeile.offsetWidth;
        zeile.setAttribute('data-ns-frisch', '1');
      }
    }

    [a, b].forEach(function (feld) {
      feld.addEventListener('input', zeichnen);
      // Nach dem ersten Buchstaben weiter ins zweite Feld: zwei
      // Felder, ein Zug.
      feld.addEventListener('input', function () {
        if (feld === a && feld.value && b.value === '') b.focus();
      });
    });

    zeichnen();
  }

  NS.monogramm = monogrammStarten;

  /* ============================================================
     Welt-Gimmick · ein Modul, vier Modi

     sternzeichen  Datum -> Zeichen, mit Darstellungs-Umschalter
     zahlen        Datum -> Ziffer, ALLE acht Ziffern, strikt 1-9
     symbole       Symbol-Kacheln mit Einblendung
     initialen     Monogramm aus zwei Buchstaben

     Rechnung und Texte kommen aus denselben Quellen wie ueberall:
     NS.zeichenFinden / NS.lebenszahl und coin-pdp-data.json.

     PARAMETER (Runde 12: Gates offen): der CTA traegt view, design,
     in den Datums-Modi dob, im Symbole-Modus symbol= und im
     Initialen-Modus initials=. Der ausgelieferte Block liest beide
     (:7256 und :7241), nachgemessen am 09.09.2026 - siehe
     docs/editor-vertrag.md.
     ============================================================ */
  function weltStarten2(root, opt) {
    if (!einmal(root, 'nsWeltGimmick')) return;
    opt = opt || {};
    var modus = opt.modus || 'sternzeichen';

    /* Kam der Besucher von einer PDP (?produkt=<handle>), zeigt der
       CTA auf dieses Stueck. Einmal an der Basis, damit jeder
       spaetere Schreibvorgang sie erbt. */
    if (opt.ctaBasis) opt.ctaBasis = produktErsetzen(opt.ctaBasis, modus);

    var feld = root.querySelector('[data-ns-welt-datum]');
    var overlay = root.querySelector('[data-ns-welt-overlay]');
    var zeile = root.querySelector('[data-ns-welt-zeile]');
    var cta = root.querySelector('[data-ns-welt-cta]');

    var artwork = root.querySelector('[data-ns-welt-artwork]');
    var sternbild = root.querySelector('[data-ns-welt-sternbild]');
    var ziffer = root.querySelector('[data-ns-welt-ziffer]');
    var symbolSvg = root.querySelector('[data-ns-welt-symbol] path');
    var mono = root.querySelector('[data-ns-welt-mono]');
    var initA = root.querySelector('[data-ns-welt-init-a]');
    var initB = root.querySelector('[data-ns-welt-init-b]');

    var dstKnoepfe = alle('[data-ns-welt-dst]', root);
    var symbolKnoepfe = alle('[data-ns-welt-symbolwahl]', root);

    var dst = 'artwork';
    var daten = null;

    function nurZiffernFeld() { return String((feld && feld.value) || '').replace(/\D/g, ''); }

    function datumsModus() { return modus === 'sternzeichen' || modus === 'zahlen'; }

    function zeichnen() {
      ungueltigMarkieren(feld, false);
      if (datumsModus()) {
        var ziffern = nurZiffernFeld();
        var fertig = ziffern.length === 8;

        var formatiert = datumFormat(ziffern);
        if (feld.value !== formatiert) {
          var amEnde = feld.selectionStart === feld.value.length;
          feld.value = formatiert;
          if (amEnde) feld.setSelectionRange(formatiert.length, formatiert.length);
        }

        if (!fertig) {
          if (overlay) overlay.setAttribute('data-ns-on', '0');
          if (zeile) zeile.textContent = opt.hinweis || '';
          if (cta) cta.setAttribute('href', opt.ctaBasis || '#');
          seitenCta('dob', null);
          return;
        }

        if (!datumGueltig(ziffern)) {
          if (overlay) overlay.setAttribute('data-ns-on', '0');
          if (zeile) zeile.textContent = textUngueltig();
          if (cta) cta.setAttribute('href', opt.ctaBasis || '#');
          seitenCta('dob', null);
          ungueltigMarkieren(feld, true);
          return;
        }

        var tag = Number(ziffern.slice(0, 2));
        var monat = Math.min(12, Math.max(1, Number(ziffern.slice(2, 4))));

        if (modus === 'zahlen') {
          // ALLE acht Ziffern, inklusive Jahr, reduziert auf 1-9.
          var n = lebenszahl(ziffern);
          if (ziffer) ziffer.textContent = String(n);
          var bed = daten && daten.numerology_meanings ? daten.numerology_meanings[String(n)] : null;
          if (zeile) {
            zeile.textContent = bed
              ? (opt.zahlLabel || text('weltZahl', 'Lebenszahl')) + ' ' + n + ' · ' + bed.keywords
              : (opt.zahlLabel || text('weltZahl', 'Lebenszahl')) + ' ' + n;
          }
        } else {
          var z = zeichenFinden(tag, monat);
          if (z) {
            if (artwork && opt.zodiacArt && opt.zodiacArt[z.key]) {
              var neu = opt.zodiacArt[z.key];
              if (artwork.getAttribute('src') !== neu) artwork.setAttribute('src', neu);
            }
            var zd = daten && daten.zodiac ? daten.zodiac[z.key] : null;
            var name = (zd && zd.name) || z.name;
            var dstZeile = dst === 'sternbild' ? opt.dstZeileSternbild : opt.dstZeileArtwork;
            // Motiv aus (Runde 35/36): kein Artwork zu benennen, die Zeile
            // nennt den Anhaenger, in den der CTA fuehrt.
            if (opt.motivZeigen === false && opt.dstZeileOhneMotiv) {
              var hm = String(opt.ctaBasis || '').match(/\/products\/([^/?#]+)/);
              var pn = (hm && opt.produktNamen && opt.produktNamen[hm[1]]) || '';
              dstZeile = opt.dstZeileOhneMotiv.replace('{produkt}', pn).replace(/\s+\./, '.');
            }
            if (zeile) zeile.textContent = name + (dstZeile ? ' · ' + dstZeile : '');
          }
          if (artwork) artwork.style.display = dst === 'artwork' ? 'block' : 'none';
          if (sternbild) sternbild.style.display = dst === 'sternbild' ? 'block' : 'none';
        }

        if (overlay) overlay.setAttribute('data-ns-on', '1');
        // In den Datums-Modi traegt der CTA dob=; symbol= und
        // initials= gehoeren den beiden anderen Modi.
        if (cta && opt.ctaBasis) cta.setAttribute('href', opt.ctaBasis + '&dob=' + isoAus(ziffern));
        seitenCta('dob', isoAus(ziffern));

      } else if (modus === 'symbole') {
        var aktiv = symbolKnoepfe.filter(function (k) { return k.getAttribute('aria-pressed') === 'true'; })[0] || symbolKnoepfe[0];
        if (!aktiv) return;
        if (symbolSvg) symbolSvg.setAttribute('d', aktiv.getAttribute('data-ns-pfad') || '');
        if (zeile) zeile.textContent = (aktiv.getAttribute('data-ns-name') || '') + ' · ' + (aktiv.getAttribute('data-ns-zeile') || '');
        if (overlay) overlay.setAttribute('data-ns-on', '1');
        // symbol= nur, wenn die Kachel einen Editor-Wert traegt.
        // Ohne Wert bleibt der CTA auf der Basis - lieber keine
        // Vorauswahl als eine erfundene.
        if (cta && opt.ctaBasis) {
          var key = (aktiv.getAttribute('data-ns-key') || '').trim();
          cta.setAttribute('href', key
            ? opt.ctaBasis + '&symbol=' + encodeURIComponent(key)
            : opt.ctaBasis);
        }

      } else {
        var x = buchstabe(initA), y = buchstabe(initB);
        var voll = !!(x && y);
        /* Runde 49: "A & M" wie das Ornament (Runde 47) und der
           Editor (Stil Initialen + Zeichen, Vorgabe amp). */
        if (mono) mono.textContent = voll ? x + ' & ' + y : '';
        if (overlay) overlay.setAttribute('data-ns-on', voll ? '1' : '0');
        if (zeile) {
          zeile.textContent = voll
            ? x + ' & ' + y + ' · ' + (opt.monoZeile || '')
            : (opt.hinweis || '');
        }
        // initials= erst, wenn beide Buchstaben stehen - der Editor
        // nimmt ein bis zwei, halb ausgefuellt zeigt das Modul aber
        // ohnehin kein Monogramm.
        if (cta && opt.ctaBasis) {
          cta.setAttribute('href', voll
            ? opt.ctaBasis + '&initials=' + encodeURIComponent(x + y)
            : opt.ctaBasis);
        }
      }

      if (zeile) {
        zeile.setAttribute('data-ns-frisch', '0');
        void zeile.offsetWidth;
        zeile.setAttribute('data-ns-frisch', '1');
      }
    }

    function buchstabe(feldEl) {
      if (!feldEl) return '';
      var wert = (feldEl.value || '').replace(/[^\p{L}]/gu, '').slice(-1).toUpperCase();
      if (feldEl.value !== wert) feldEl.value = wert;
      return wert;
    }

    if (feld) feld.addEventListener('input', zeichnen);

    dstKnoepfe.forEach(function (k) {
      k.addEventListener('click', function () {
        dst = k.getAttribute('data-ns-welt-dst');
        dstKnoepfe.forEach(function (o) { o.setAttribute('aria-pressed', o === k ? 'true' : 'false'); });
        zeichnen();
      });
    });

    symbolKnoepfe.forEach(function (k) {
      k.addEventListener('click', function () {
        symbolKnoepfe.forEach(function (o) { o.setAttribute('aria-pressed', o === k ? 'true' : 'false'); });
        zeichnen();
      });
    });

    [initA, initB].forEach(function (f) {
      if (!f) return;
      f.addEventListener('input', function () {
        zeichnen();
        if (f === initA && f.value && initB && initB.value === '') initB.focus();
      });
    });

    datenLaden(opt.datenUrl).then(function (d) {
      daten = paket(d);
      zeichnen();
    }).catch(zeichnen);

    zeichnen();
  }

  NS.welt = weltStarten2;

  /* ============================================================
     Geburtskarten-Rechner
     Solo ein Datum, Paar zwei - beide fliessen in EINE Summe.
     Der CTA traegt card=<Index 0-21>, nicht karte= und keine
     roemische Ziffer (Kontrakt-Korrektur gegen die Referenz).
     ============================================================ */
  function geburtsrechnerStarten(root, opt) {
    if (!einmal(root, 'nsGeb')) return;
    opt = opt || {};

    var a = root.querySelector('[data-ns-geb-a]');
    var b = root.querySelector('[data-ns-geb-b]');
    var zeile = root.querySelector('[data-ns-geb-zeile]');
    var ergebnis = root.querySelector('[data-ns-geb-ergebnis]');
    var bild = root.querySelector('[data-ns-geb-bild]');
    var elNr = root.querySelector('[data-ns-geb-nummer]');
    var elName = root.querySelector('[data-ns-geb-name]');
    var elKey = root.querySelector('[data-ns-geb-keywords]');
    var elRead = root.querySelector('[data-ns-geb-reading]');
    var cta = root.querySelector('[data-ns-geb-cta]');
    var modusKnoepfe = alle('[data-ns-geb-modus]', root);
    if (!a) return;

    var modus = 'solo';
    var karten = [], bilder = [];

    function ziffern(feld) {
      if (!feld) return '';
      var z = String(feld.value || '').replace(/\D/g, '').slice(0, 8);
      var f = datumFormat(z);
      if (feld.value !== f) {
        var amEnde = feld.selectionStart === feld.value.length;
        feld.value = f;
        if (amEnde) feld.setSelectionRange(f.length, f.length);
      }
      return z;
    }

    function zeichnen() {
      var za = ziffern(a);
      var zb = modus === 'paar' ? ziffern(b) : '';
      var fertig = modus === 'paar' ? (za.length === 8 && zb.length === 8) : za.length === 8;

      if (b) b.hidden = modus !== 'paar';
      modusKnoepfe.forEach(function (k) {
        k.setAttribute('aria-pressed', k.getAttribute('data-ns-geb-modus') === modus ? 'true' : 'false');
      });

      ungueltigMarkieren(a, false);
      ungueltigMarkieren(b, false);

      if (!fertig || karten.length === 0) {
        if (ergebnis) ergebnis.hidden = true;
        if (zeile) zeile.textContent = modus === 'paar' ? (opt.hinweisPaar || '') : (opt.hinweis || '');
        return;
      }

      var aFalsch = !datumGueltig(za);
      var bFalsch = modus === 'paar' && !datumGueltig(zb);
      if (aFalsch || bFalsch) {
        ungueltigMarkieren(a, aFalsch);
        ungueltigMarkieren(b, bFalsch);
        if (ergebnis) ergebnis.hidden = true;
        if (cta && opt.ctaBasis) cta.setAttribute('href', opt.ctaBasis);
        seitenCta('card', null);
        if (zeile) zeile.textContent = textUngueltig();
        return;
      }

      var idx = geburtskarte(modus === 'paar' ? [za, zb] : [za]);
      var k = karten[idx];
      if (!k) return;

      if (elNr) elNr.textContent = k.number || '';
      if (elName) elName.textContent = k.name || '';
      if (elKey) elKey.textContent = k.keywords || '';
      if (elRead) elRead.textContent = k.text || '';
      if (bild && bilder[idx]) { bild.setAttribute('src', bilder[idx]); bild.setAttribute('alt', k.name || ''); }
      // KONTRAKT: card=<Index>, numerisch.
      if (cta && opt.ctaBasis) cta.setAttribute('href', opt.ctaBasis + '&design=tarot&card=' + idx);
      seitenCta('card', idx);
      if (zeile) zeile.textContent = '';
      if (ergebnis) ergebnis.hidden = false;
    }

    [a, b].forEach(function (f) { if (f) f.addEventListener('input', zeichnen); });
    modusKnoepfe.forEach(function (k) {
      k.addEventListener('click', function () {
        modus = k.getAttribute('data-ns-geb-modus');
        zeichnen();
        if (modus === 'paar' && b) b.focus();
      });
    });

    datenLaden(opt.datenUrl).then(function (d) {
      karten = (paket(d) && paket(d).tarot) || [];
      bilder = tarotBilder(d, karten.length);
      zeichnen();
    }).catch(zeichnen);

    zeichnen();
  }

  NS.geburtsrechner = geburtsrechnerStarten;

  /* ============================================================
     Die 22 Grossen Arkana als Kachelband
     Die Kacheln entstehen hier, nicht im Template: die Namen und
     Artworks stehen in coin-pdp-data.json, und eine zweite Liste
     waere eine zweite Quelle.
     ============================================================ */
  function arkanaStarten(root, opt) {
    if (!einmal(root, 'nsArkana')) return;
    opt = opt || {};
    var rail = root.querySelector('[data-ns-arkana-rail]');
    if (!rail) return;

    datenLaden(opt.datenUrl).then(function (d) {
      var karten = (paket(d) && paket(d).tarot) || [];
      if (karten.length === 0) return;
      var bilder = tarotBilder(d, karten.length);
      var hinweis = rail.querySelector('[data-ns-arkana-hinweis]');
      if (hinweis) hinweis.remove();
      var ende = rail.querySelector('.ns-kband__ende');

      karten.forEach(function (k, i) {
        var a = document.createElement('a');
        a.className = 'ns-kachel ns-arkana__kachel';
        a.setAttribute('href', opt.ctaBasis + '&card=' + i);

        var slot = document.createElement('div');
        slot.className = 'ns-slot';
        if (bilder[i]) {
          var im = document.createElement('img');
          im.src = bilder[i];
          im.alt = k.name || '';
          im.loading = 'lazy';
          im.width = 600; im.height = 800;
          slot.appendChild(im);
        }
        a.appendChild(slot);

        var label = document.createElement('span');
        label.className = 'ns-arkana__label';
        var nr = document.createElement('span');
        nr.className = 'ns-arkana__nr';
        nr.textContent = k.number || '';
        var nm = document.createElement('span');
        nm.className = 'ns-arkana__name';
        nm.textContent = k.name || '';
        label.appendChild(nr);
        label.appendChild(nm);
        a.appendChild(label);

        rail.insertBefore(a, ende);
      });

      // Das Kachelband kennt seine Breite erst jetzt.
      var pfeil = root.querySelector('[data-ns-kband-pfeil]');
      if (pfeil) pfeil.setAttribute('data-ns-ende', rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 12 ? '1' : '0');
    }).catch(function () {});
  }

  NS.arkana = arkanaStarten;

  /* ============================================================
     Durchreichen · design, dob und card wandern mit

     Wer die Startseite mit ?design=sternzeichen&dob=1990-03-14
     verlaesst und auf einer PDP landet, soll den Editor in
     derselben Welt oeffnen. Bisher endete die Absicht an der
     Produktseite.

     Rein additiv: ohne Parameter in der URL bleibt jeder Link
     exakt wie zuvor, und ein Parameter, den der Link schon
     selbst traegt, wird nie ueberschrieben.

     Das Vokabular steht in docs/editor-vertrag.md, belegt aus
     ~/marked-editor. Eine Welt gilt nur fuer die Produkte, die sie
     kennen; was ein Produkt nicht kennt, faellt im Editor still auf
     dessen Default zurueck, und so ein Link wird gar nicht erst
     gebaut.

     STAND 30.09.2026, Block 409: Card (Config 14) und Ornament
     (Config 15) haben Rueckseiten und die Zahlen-Welt bekommen.
     zahlen greift jetzt auf allen drei Anhaengern, sternzeichen
     auch auf dem Ornament. Damit fallen die Ausnahmen aus Runde 11
     - jede Welt-Kachel fuehrt zu ihrem eigenen Produkt mit ihrer
     eigenen Welt.

     Die Welten sind nach Anhaengergroesse gestaffelt (Ornament
     einfach, Coin mittel, Card aufwendig), verbindlich in
     ~/marked-editor/docs/welten-staffelung.md. Die Staffelung
     betrifft den Umfang IM Editor, nicht die Erreichbarkeit: auf
     dem Ornament fuehrt zahlen zur Lebenszahl ohne Engelszahlen,
     sternzeichen zur Glyphe. Deep-Link ist derselbe.

     Tarot bleibt allein auf der Card. Diese eine Grenze traegt die
     Tabelle weiter.
     ============================================================ */
  var WELTEN_JE_PRODUKT = {
    'pendant-coin': ['zahlen', 'sternzeichen', 'symbole', 'initialen'],
    'pendant-card': ['tarot', 'symbole', 'initialen', 'sternzeichen', 'zahlen'],
    'ornament-pendant': ['symbole', 'initialen', 'zahlen', 'sternzeichen']
  };

  function dobGueltig(w) {
    var teile = String(w).split(/[-\/.]/);
    if (teile.length !== 3) return false;
    for (var i = 0; i < 3; i++) if (!/^\d{1,4}$/.test(teile[i])) return false;
    // JJJJ-MM-TT oder TT-MM-JJJJ, wie der Editor; dann gegen den Kalender.
    var iso = teile[0].length === 4;
    var tag = iso ? teile[2] : teile[0], monat = teile[1], jahr = iso ? teile[0] : teile[2];
    if (jahr.length !== 4 || tag.length > 2 || monat.length > 2) return false;
    return datumGueltig(('0' + tag).slice(-2) + ('0' + monat).slice(-2) + jahr);
  }

  /* Einmal-Sperre als Variable, nicht am DOM: die Funktion laeuft
     vor allem anderen und darf nicht davon abhaengen, dass es schon
     ein body-Element mit dataset gibt. */
  var durchgereicht = false;

  function durchreichenStarten(wurzel) {
    if (durchgereicht) return;
    durchgereicht = true;
    var doc = wurzel || document;

    var such;
    try { such = new URLSearchParams(window.location.search); } catch (e) { return; }
    var design = such.get('design');
    var dob = such.get('dob');
    var card = such.get('card');

    if (dob && !dobGueltig(dob)) dob = null;
    if (card !== null) {
      var n = parseInt(card, 10);
      card = (!isNaN(n) && n >= 0 && n <= 21) ? String(n) : null;
    }
    if (!design && !dob && !card) return;

    alle('a[href]', doc).forEach(function (a) {
      var roh = a.getAttribute('href') || '';
      if (roh.indexOf('view=fullscreen') < 0) return;

      var ziel;
      try { ziel = new URL(a.href, window.location.origin); } catch (e) { return; }

      /* Die Welt gilt nur, wenn das Zielprodukt sie kennt. */
      if (design && !ziel.searchParams.get('design')) {
        var m = ziel.pathname.match(/\/products\/([^/?#]+)/);
        var welten = m ? WELTEN_JE_PRODUKT[m[1]] : null;
        if (welten && welten.indexOf(design) > -1) ziel.searchParams.set('design', design);
      }
      if (dob && !ziel.searchParams.get('dob')) ziel.searchParams.set('dob', dob);
      /* card ergibt nur in der Tarot-Welt Sinn. */
      if (card !== null && !ziel.searchParams.get('card')
          && ziel.searchParams.get('design') === 'tarot') {
        ziel.searchParams.set('card', card);
      }
      a.setAttribute('href', ziel.pathname + ziel.search + ziel.hash);
    });
  }

  NS.durchreichen = durchreichenStarten;

  /* ============================================================
     Seiten-CTA · Hero und Final-Block der Welt-Seiten (Runde 43)

     Stufe 1 der CTA-Regel ist auf den fuenf Welt-Seiten aufgehoben:
     Hero und Final-Block tragen design=<slug> schon im Liquid
     (data-ns-seiten-cta). Was die Seite dazu lernt, wandert mit:
     dob= aus dem Datumsfeld der Welt (sternzeichen, zahlen), card=
     aus Geburtskarte oder gezogener Karte (tarot).

     Die Basis ist der href nach Sprachpraefix und Durchreichen,
     beim ersten Schreiben gemerkt. Ein Wert, den die Basis schon
     traegt (?dob= in der Seiten-URL), wird ersetzt, solange die
     Seite einen eigenen kennt, und kehrt zurueck, wenn das Feld
     wieder leer oder ungueltig ist.

     Ohne Eingabe bleibt card= weg: die Startkarte der Zeremonie hat
     niemand gewaehlt.
     ============================================================ */
  var SEITEN_PARAM_WELTEN = {
    dob: ['sternzeichen', 'zahlen'],
    card: ['tarot']
  };

  function seitenCta(name, wert) {
    var welten = SEITEN_PARAM_WELTEN[name];
    if (!welten) return;
    alle('a[data-ns-seiten-cta]').forEach(function (a) {
      if (welten.indexOf(a.getAttribute('data-ns-welt-design') || '') < 0) return;
      if (!a.hasAttribute('data-ns-basis')) a.setAttribute('data-ns-basis', a.getAttribute('href') || '');
      var ziel;
      try { ziel = new URL(a.getAttribute('data-ns-basis'), window.location.origin); } catch (e) { return; }
      /* Stand der anderen Parameter aus dem aktuellen href uebernehmen. */
      var jetzt;
      try { jetzt = new URL(a.getAttribute('href') || '', window.location.origin); } catch (e) { jetzt = ziel; }
      Object.keys(SEITEN_PARAM_WELTEN).forEach(function (n) {
        if (n !== name && jetzt.searchParams.has(n)) ziel.searchParams.set(n, jetzt.searchParams.get(n));
      });
      if (wert !== null && wert !== undefined && wert !== '') ziel.searchParams.set(name, String(wert));
      a.setAttribute('href', ziel.pathname + ziel.search + ziel.hash);
    });
  }

  NS.seitenCta = seitenCta;

  /* ============================================================
     Welt-Seite kennt das Produkt

     Die Welten-Kacheln der drei PDPs haengen ?produkt=<handle> an.
     Kommt der Besucher so auf einer Welt-Seite an, soll ihr
     Editor-CTA auf DIESES Stueck zeigen statt auf das Produkt aus
     dem Section-Setting.

     Zwei Bedingungen, sonst bleibt alles wie es ist: der Handle
     muss einer der drei aktiven sein, UND das Produkt muss die
     Welt der Section kennen. Sonst faellt der Link im Editor auf
     dessen Default zurueck, und der Besucher landet in einer
     anderen Welt als angeklickt.

     Seit Block 409 greift die zweite Bedingung nur noch bei Tarot.
     Die Welt-Seiten Lebenszahl und Sternzeichen fuehren ab jetzt
     auch auf Card und Ornament, wenn die Kachel von dort kommt.

     Seit Runde 46 gilt das auch fuer Hero und Final der Welt-Seiten
     (a[data-ns-seiten-cta]), mit denselben zwei Bedingungen.
     ============================================================ */
  /* Reine Funktion, kein einmaliges Umschreiben am DOM: das
     Welt-Modul schreibt den href bei jeder Eingabe neu aus seiner
     Basis-URL. Wer nur einmal am Element umschreibt, verliert das
     beim ersten Tastendruck. Also wirkt die Ersetzung auf die
     BASIS, und jeder spaetere Schreibvorgang erbt sie. */
  function produktErsetzen(basis, design) {
    if (!basis) return basis;
    var such;
    try { such = new URLSearchParams(window.location.search); } catch (e) { return basis; }
    var handle = such.get('produkt');
    if (!handle) return basis;

    var welten = WELTEN_JE_PRODUKT[handle];
    if (!welten) return basis;                        // unbekannter Handle
    if (design && welten.indexOf(design) < 0) return basis;  // Produkt kennt die Welt nicht

    /* Ersetzt nur den Handle. Ein Sprachpraefix im Pfad bleibt
       dabei stehen, weil das Muster erst bei /products/ greift. */
    return String(basis).replace(/\/products\/[^/?#]+/, '/products/' + handle);
  }

  function weltProduktStarten(cta) {
    if (!einmal(cta, 'nsWeltProdukt')) return;
    var design = cta.getAttribute('data-ns-welt-design') || '';
    var neu = produktErsetzen(cta.getAttribute('href') || '', design);
    if (neu) cta.setAttribute('href', neu);
  }

  NS.weltProdukt = weltProduktStarten;

  /* Runde 47: "Die anderen Welten" auf einer Welt-Seite. Kam der
     Besucher mit ?produkt=<handle>, fuehren die Kacheln zur
     naechsten Welt-Seite mit demselben ?produkt=, wie es die
     Kacheln der PDPs schon im Liquid tun (ns-welten.liquid). Nicht
     an "Nur The Card" (Tarot), nicht bei unbekanntem Handle, nicht
     an Links, die schon ein produkt= tragen. */
  function weltKachelnProdukt(wurzelEl) {
    var such;
    try { such = new URLSearchParams(window.location.search); } catch (e) { return; }
    var handle = such.get('produkt');
    if (!handle || !WELTEN_JE_PRODUKT[handle]) return;
    alle('a[data-ns-welt]', wurzelEl || document).forEach(function (a) {
      if (!einmal(a, 'nsWeltKachelProdukt')) return;
      if (a.hasAttribute('data-ns-nur-card')) return;
      var roh = a.getAttribute('href') || '';
      if (roh.indexOf('/pages/') < 0) return;
      var ziel;
      try { ziel = new URL(roh, window.location.origin); } catch (e) { return; }
      if (ziel.origin !== window.location.origin || ziel.searchParams.has('produkt')) return;
      ziel.searchParams.set('produkt', handle);
      a.setAttribute('href', ziel.pathname + ziel.search + ziel.hash);
    });
  }

  NS.weltKachelnProdukt = weltKachelnProdukt;

  /* Initialen-Beispiele (Runde 48): Auf der Welt Initialen zeigen die
     drei Beispiele den Anhaenger aus ?produkt=, Bild und Editor-Link
     gemeinsam. Ohne produkt= oder mit unbekanntem Handle bleibt das
     Liquid (Medallion). */
  var INI_BSP_BILD = { 'pendant-coin': 'nsIniBspCoin', 'pendant-card': 'nsIniBspCard', 'ornament-pendant': 'nsIniBspOrnament' };

  function iniBeispieleProdukt(wurzelEl) {
    var such;
    try { such = new URLSearchParams(window.location.search); } catch (e) { return; }
    var handle = such.get('produkt');
    if (!handle || !INI_BSP_BILD[handle]) return;
    alle('[data-ns-ini-bsp] a[data-ns-ini-bsp-n]', wurzelEl || document).forEach(function (a) {
      if (!einmal(a, 'nsIniBspProdukt')) return;
      var bild = a.dataset[INI_BSP_BILD[handle]];
      var img = a.querySelector('img');
      if (bild && img) img.setAttribute('src', bild);
      var ziel;
      try { ziel = new URL(a.getAttribute('href') || '', window.location.origin); } catch (e) { return; }
      ziel.pathname = ziel.pathname.replace(/\/products\/[^/]+$/, '/products/' + handle);
      // Die Card kennt keinen stil (nur Initialen + Zeichen).
      if (handle === 'pendant-card') ziel.searchParams.delete('stil');
      else if (!ziel.searchParams.has('stil')) ziel.searchParams.set('stil', 'initialen_zeichen');
      a.setAttribute('href', ziel.pathname + ziel.search + ziel.hash);
    });
  }

  NS.iniBeispieleProdukt = iniBeispieleProdukt;

  /* ============================================================
     Produkt-Kacheln · Silber/Gold-Wechsel (Runde 18)

     AUSNAHME VON DER MOTION-REGEL: Karussells sliden, hier wird
     bewusst uebergeblendet. Es ist kein Karussell, sondern dasselbe
     Stueck in zwei Farben an derselben Stelle; ein Slide wuerde eine
     Bewegung vortaeuschen, die es nicht gibt.

     Ein Takt fuer die ganze Section (5 s), Uebergang 1,2 s im CSS.
     Phase nach Position (data-ns-phase 0/1 aus dem Liquid): Gold
     zeigt, wer (Zustand XOR Phase) = 1 hat. Beim Start kippt also
     nur Kachel 2 auf Gold, danach kippen alle gleichzeitig.

     Start erst, wenn alle beteiligten Bilder dekodiert sind (lazy
     bleibt lazy: decode() wartet, bis der Browser sie holt). Pause,
     solange die Section nicht im Bild oder der Tab verdeckt ist.
     prefers-reduced-motion: kein Wechsel, alle zeigen Silber.
     ============================================================ */
  var FARBWECHSEL_TAKT = 5000;

  function farbwechselStarten(root) {
    if (!einmal(root, 'nsFarbwechsel')) return;
    var kacheln = alle('[data-ns-phase]', root);
    if (!kacheln.length || reduziert()) return;

    var zustand = 0;
    var timer = null;
    var sichtbar = false;
    var bereit = false;

    function setzen() {
      kacheln.forEach(function (k) {
        var phase = k.getAttribute('data-ns-phase') === '1' ? 1 : 0;
        k.setAttribute('data-ns-gold', String(zustand ^ phase));
      });
    }

    function halt() { if (timer) { clearInterval(timer); timer = null; } }

    function lauf() {
      halt();
      // Theme-Editor: die Section wurde neu gebaut, dieser Takt ist verwaist.
      if (!document.documentElement.contains(root)) {
        document.removeEventListener('visibilitychange', lauf);
        return;
      }
      if (!bereit || !sichtbar || document.hidden) return;
      timer = setInterval(function () {
        if (!document.documentElement.contains(root)) { lauf(); return; }
        zustand = 1 - zustand;
        setzen();
      }, FARBWECHSEL_TAKT);
    }

    var bilder = [];
    kacheln.forEach(function (k) {
      alle('img', k).forEach(function (i) { bilder.push(i); });
    });
    Promise.all(bilder.map(function (i) {
      return i.decode ? i.decode() : Promise.resolve();
    })).then(function () {
      bereit = true;
      setzen();
      lauf();
    }, function () { /* ein Bild fehlt: es bleibt bei Silber */ });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) { sichtbar = e.isIntersecting; lauf(); });
      }, { threshold: 0.25 }).observe(root);
    } else {
      sichtbar = true;
    }
    document.addEventListener('visibilitychange', lauf);
  }

  NS.farbwechsel = farbwechselStarten;

  /* ============================================================
     Aufsammeln
     ============================================================ */
  /* ----------------------------------------------------------
     PDP-Sticky (Runde 45): Solange ein anderer Bordeaux-Knopf der
     Seite im Bild ist, bekommt die Leiste ns-pdpsticky--neutral.
     Bordeaux heisst: berechneter Grund #522628 oder #3f1e20, nicht
     die Klasse (.ns-gravur__cta faerbt auch --cream Bordeaux, ein
     gewaehlter Chip ist ebenfalls Bordeaux). Chips wechseln den
     Grund beim Tippen, deshalb zaehlt der Grund im Moment der
     Meldung. Ohne IntersectionObserver bleibt alles wie vorher.
     ---------------------------------------------------------- */
  var BORDEAUX = ['rgb(82, 38, 40)', 'rgb(63, 30, 32)'];
  function istBordeaux(e) {
    return BORDEAUX.indexOf(getComputedStyle(e).backgroundColor) > -1;
  }
  function pdpStickyStarten(leiste) {
    if (leiste.__nsSticky || !('IntersectionObserver' in window)) return;
    leiste.__nsSticky = true;
    var ziele = alle('.ns a, .ns button').filter(function (b) {
      return !leiste.contains(b) && b.textContent.trim();
    });
    if (!ziele.length) return;
    var sichtbar = new Set();
    function stellen() {
      var an = false;
      sichtbar.forEach(function (b) { if (!an && istBordeaux(b)) an = true; });
      leiste.classList.toggle('ns-pdpsticky--neutral', an);
    }
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) sichtbar.add(e.target); else sichtbar.delete(e.target);
      });
      stellen();
    }, { rootMargin: '0px 0px -' + leiste.offsetHeight + 'px 0px' });
    ziele.forEach(function (b) { io.observe(b); });
    document.addEventListener('click', function () { setTimeout(stellen, 0); });
  }

  function starten() {
    /* Erst das Produkt setzen, dann durchreichen: sonst haengt das
       Durchreichen seine Parameter an einen Link, dessen Produkt
       gleich darauf wechselt. */
    /* Zuerst das Sprachpraefix: danach arbeiten Produkt-Ersetzung
       und Durchreichen auf Pfaden, die schon richtig liegen. */
    linkPraefixStarten(document);
    /* Runde 46: Hero und Final der Welt-Seiten (data-ns-seiten-cta)
       folgen ?produkt= wie die Modul-Kachel. Vor dem ersten
       seitenCta(), damit data-ns-basis das ersetzte Produkt merkt. */
    alle('[data-ns-welt-cta], a[data-ns-seiten-cta]').forEach(weltProduktStarten);
    weltKachelnProdukt(document);
    iniBeispieleProdukt(document);
    durchreichenStarten(document);
    alle('[data-ns-band]').forEach(bandStarten);
    alle('[data-ns-menu]').forEach(menueStarten);
    alle('[data-ns-slider]').forEach(function (r) { sliderStarten(r); });
    alle('[data-ns-farbwahl]').forEach(farbwahlStarten);
    alle('[data-ns-sticky-neutral]').forEach(pdpStickyStarten);
    alle('[data-ns-kband]').forEach(kbandStarten);
    alle('[data-ns-wechsel]').forEach(wechselStarten);
    alle('[data-ns-farbwechsel]').forEach(farbwechselStarten);
    alle('[data-ns-welt]').forEach(weltStarten);
  }

  NS.starten = starten;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }

  // Theme-Editor: nach dem Neuladen einer Section erneut aufsammeln.
  document.addEventListener('shopify:section:load', starten);
})();
